import axios from 'axios';
import { DocAIModel, DocAIResultModel, OllamaModel, OllamaResultModel } from '../models/docaiModel';

export const OllamaApi = async (library: string, data: OllamaModel): Promise<OllamaResultModel | null> => {  
  const baseUrl = "http://192.168.148.41:11434/api/generate";

  var result: Promise<OllamaResultModel> = axios.post(baseUrl, data)
    .then(response => {
      var basedata = response.data as OllamaResultModel;
      if (basedata.done) {
        return basedata;
      }
      
      console.error(result);
      throw new Error(result + "");
    })
    .catch(error => {
      console.error(error);
      throw new Error(error.response.status);
    });

    return result;
};

export const docAIApi = async (data: DocAIModel, token: string, faiss: boolean): Promise<DocAIResultModel | null> => {  

  const baseUrl = faiss ? "https://docaiapifaiss.docvirt.com/ask" : "https://docaiapi.docvirt.com/ask";
  const headers = token !== "" ? {headers: {Authorization: `Bearer ${token}`}} : {headers: {Authorization: `none`}};

  var result: Promise<DocAIResultModel> = axios.post(baseUrl, data, headers)
    .then(response => {
      var basedata = response.data as DocAIResultModel;
      if (basedata.answer != "") {
        return basedata;
      }
      
      console.error(result);
      throw new Error(result + "");
    })
    .catch(error => {
      console.error(error);
      throw new Error(error);
    });

    return result;
};